import React from "react";

import { Box, Typography } from "@mui/material";

import { KeyFeatureProps } from "./type";

export const KeyFeature: React.FC<KeyFeatureProps> = ({
  title,
  content,
  FeatureImage,
}) => (
  <Box display="flex" flexDirection="column" alignItems="center" rowGap={1}>
    <FeatureImage />
    <Typography variant="h5" component="h3" align="center">
      {title}
    </Typography>
    <Typography variant="subtitle1" component="p">
      {content}
    </Typography>
  </Box>
);
